import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'addHtmlLineBreaks',
	pure: true,
	standalone: false
})
export class AddHtmlLineBreaksPipe implements PipeTransform {
	constructor() {}

	transform(text: string | undefined | null): string | undefined {
		if (!text) {
			return undefined;
		}
		return text.toString().replace(/(?:\r\n|\r|\n)/g, ' <br /> ');
	}
}
